const principles = [
  {
    icon: 'ri-shield-check-line',
    title: 'Integridade',
    description:
      'Actuamos com total transparência e honestidade em todas as nossas relações, colocando sempre os interesses dos nossos clientes em primeiro lugar.',
  },
  {
    icon: 'ri-focus-3-line',
    title: 'Excelência',
    description:
      'Comprometemo-nos com os mais altos padrões de qualidade em cada projecto, entregando resultados que superam as expectativas dos nossos clientes.',
  },
  {
    icon: 'ri-lightbulb-line',
    title: 'Inovação',
    description:
      'Aplicamos pensamento criativo e soluções inovadoras para resolver os desafios mais complexos do ambiente empresarial angolano.',
  },
  {
    icon: 'ri-team-line',
    title: 'Parceria',
    description:
      'Construímos relações de longo prazo baseadas na confiança mútua, tornando-nos verdadeiros parceiros estratégicos no crescimento dos nossos clientes.',
  },
];

export default function PrinciplesSection() {
  return (
    <section className="bg-[#0A1F25] py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <div className="inline-flex items-center gap-2 border border-[#026A86]/40 rounded-full px-4 py-1.5 mb-6">
              <span className="text-[#026A86] text-xs font-medium tracking-widest uppercase">
                Nossos Valores
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-white leading-tight">
              Princípios que guiam
              <br />
              <span className="text-[#026A86]">a nossa actuação</span>
            </h2>
          </div>
          <p className="text-white/50 text-base max-w-sm leading-relaxed">
            Cada decisão que tomamos é orientada por um conjunto de valores
            fundamentais que definem quem somos.
          </p>
        </div>

        {/* Principles Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {principles.map((p, idx) => (
            <div
              key={p.title}
              className="group relative bg-[#0D2B35] rounded-2xl p-7 border border-[#1a3d4a] hover:border-[#026A86]/50 transition-all duration-300"
            >
              {/* Number */}
              <span className="absolute top-5 right-6 text-5xl font-bold text-white/5 select-none">
                0{idx + 1}
              </span>

              {/* Icon */}
              <div className="w-12 h-12 flex items-center justify-center bg-[#026A86]/15 rounded-xl mb-5 group-hover:bg-[#026A86]/25 transition-colors duration-300">
                <i className={`${p.icon} text-xl text-[#026A86]`} />
              </div>

              <h3 className="text-white font-bold text-lg mb-3">{p.title}</h3>
              <p className="text-white/50 text-sm leading-relaxed">{p.description}</p>

              {/* Bottom accent */}
              <div className="absolute bottom-0 left-7 right-7 h-px bg-gradient-to-r from-transparent via-[#026A86]/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
